import React from 'react';

export const LikeIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="14"
    viewBox="0 0 16 14"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <path
      d="M386,217.365a4.312,4.312,0,0,0-8-2.28,4.309,4.309,0,0,0-8,2.28,4.375,4.375,0,0,0,1.487,3.286l6.12,6.184A0.567,0.567,0,0,0,378,227a0.553,0.553,0,0,0,.4-0.165l6.12-6.184A4.375,4.375,0,0,0,386,217.365Z"
      transform="translate(-370 -213)"
    />
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/like-icon.js